
<dx-data-grid
  [dataSource]="allegatiList"
  [showBorders]="true"
  [columnAutoWidth]="true">
  <dxi-column dataField="id" [visible]="false"></dxi-column>

  <dxi-column
    name="scaricaFileAllegato"
    [allowFiltering]="false"
    [allowSorting]="false" cellTemplate="scaricaFileAllegato"
    caption=""
    width="35">
  </dxi-column>
  <dxi-column
    name="vediFile"
    [allowFiltering]="false"
    [allowSorting]="false" cellTemplate="vediFile"
    caption=""
    width="35">
  </dxi-column>
  <dxi-column
    name="deleteFile"
    [allowFiltering]="false"
    [allowSorting]="false" cellTemplate="deleteFile"
    caption=""
    width="35">
  </dxi-column>
  <dxi-column dataField="nome"></dxi-column>


  <div *dxTemplate="let d of 'scaricaFileAllegato'">
    <i class="dx-icon-download"
    (click)="scaricaFileAllegato(d.data)" style="cursor: pointer;" data-toggle="tooltip" data-placement="top" title="Scarica allegato"></i>
  </div>
  <div *dxTemplate="let d of 'vediFile'">
    @if (endsWith(d.data.nomeFile, '.jpg') || endsWith(d.data.nomeFile, '.png')) {
      <i class="dx-icon-image"
      (click)="visualizzaImmagine(d.data)" style="cursor: pointer;" data-toggle="tooltip" data-placement="top" title="Visualizza immagine"></i>
    }
    @if (endsWith(d.data.nomeFile, '.pdf')) {
      <i class="dx-icon-doc"
      (click)="visualizzaFile(d.data)" style="cursor: pointer;" data-toggle="tooltip" data-placement="top" title="Visualizza allegato"></i>
    }
  </div>
  <div *dxTemplate="let d of 'deleteFile'">
    <i class="dx-icon-trash"
    (click)="eliminaFile(d.data)" style="cursor: pointer;" data-toggle="tooltip" data-placement="top" title="Elimina allegato"></i>
  </div>
</dx-data-grid>




<dx-popup
  [width]="600"
  [height]="450"
  [showTitle]="true"
  title="Information"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [(visible)]="popupImageVisible">
  <img style="max-width: 100%; max-height: 100%;" [src]="currentImage" alt="Immagine Allegato Movimento">
</dx-popup>
